import type { SvgIconProps } from "@mui/material";
import { SvgIcon } from "@mui/material";

const FolderOpenSymbolIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 -960 960 960" {...props}>
    <path d="M168-192q-32 0-52-21.16t-20-50.88v-432.24Q96-726 116-747t52-21h185.64q14.35 0 27.36 5 13 5 24 16l75 75h349q15.3 0 25.65 10.29Q865-651.42 865-636.21t-10.35 25.71Q844.3-600 829-600H451l-96-96H168v432l63-212q7-23 26-37.5t43-14.5h539q36 0 58 29t11 64l-57 192q-8 23-21 37t-38 14H168Zm75-72h538l59-192H300l-57 192Zm-75-213v-219 219Zm75 213 57-192-57 192Z" />
  </SvgIcon>
);

export default FolderOpenSymbolIcon;
